// One supplied Time2lucky appearance per evolution stage; gender remains profile data.
const stages = [
  require('../assets/images/companion/stage-1.png'),
  require('../assets/images/companion/stage-2.png'),
  require('../assets/images/companion/stage-3.png'),
  require('../assets/images/companion/stage-4.png'),
  require('../assets/images/companion/stage-5.png'),
  require('../assets/images/companion/stage-6.png'),
  require('../assets/images/companion/stage-7.png'),
]
const animatedStages = [
  require('../assets/images/companion/stage-1-animated.png'),
  require('../assets/images/companion/stage-2-animated.png'),
  require('../assets/images/companion/stage-3-animated.png'),
  require('../assets/images/companion/stage-4-animated.png'),
  require('../assets/images/companion/stage-5-animated.png'),
  require('../assets/images/companion/stage-6-animated.png'),
  require('../assets/images/companion/stage-7-animated.png'),
]
export const qilinMenuAssets = { pet: stages[0], checkin: stages[3], mission: stages[4] }
export function qilinStageImage (stage) {
  return stages[Math.max(1, Math.min(7, Math.floor(Number(stage) || 1))) - 1]
}
// Animated PNG frames articulate the character. Static images support reduced motion.
export function qilinPetImage (pet, allowAnimation = true) {
  if (!allowAnimation) return qilinStageImage(pet && pet.stage)
  return animatedStages[Math.max(1, Math.min(7, Math.floor(Number(pet && pet.stage) || 1))) - 1]
}
